import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Text3, Text4 } from "../styled";

const InterestQuerySection = () => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#F1EDF7",
          padding: "8px 16px",
        }}
      >
        <Text3>{t("order:interestInquiryTitle")}</Text3>
      </Box>
      <Box
        sx={{
          padding: "16px",
          backgroundColor: "#FAFAFB",
        }}
      >
        <Text4>{t("order:interestInquiryText")}</Text4>
      </Box>
    </>
  );
};

export default InterestQuerySection;
